import { render, staticRenderFns } from "./moduleEdit.vue?vue&type=template&id=551d27f6&scoped=true"
import script from "./moduleEdit.vue?vue&type=script&lang=js"
export * from "./moduleEdit.vue?vue&type=script&lang=js"
import style0 from "./moduleEdit.vue?vue&type=style&index=0&id=551d27f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551d27f6",
  null
  
)

export default component.exports